function initQuickViewPriceAndCalculator() {
  var $popup = $(".popup-content");
  var pricePerBox = parseFloat($popup.find(".price_per_box_value").text().replace("$", "").trim());
  var totalPerFit2Value = parseFloat($popup.find(".total_feet_meta_value").text().trim());

  if (!isNaN(pricePerBox) && !isNaN(totalPerFit2Value) && totalPerFit2Value > 0) {
    var priceFit2Value = (pricePerBox / totalPerFit2Value).toFixed(2);
    $popup.find(".total_fit_value").text("$" + priceFit2Value);
  }

  $popup.find("#number_of_boxes").val(1);

  function updateCalculations() {
    var ft2NeededValue = parseFloat($popup.find("#ft2_needed").val());
    var overage_selected = parseFloat($popup.find("#overage option:selected").val());
    var calculate_val = ft2NeededValue * overage_selected + ft2NeededValue;
    var finalsum = Math.ceil(calculate_val / totalPerFit2Value) * totalPerFit2Value;
    $popup.find("#number_of_boxes").val(parseInt(finalsum / totalPerFit2Value));
    $popup.find("#custom_totalf2").val(finalsum);
  }

  $popup.find("#overage").off("change").on("change", updateCalculations);
  $popup.find("#ft2_needed").off("input").on("input", updateCalculations);
}

$("body").on("click", ".quick-view-button", function () {
  $(".popup-content").addClass("loading");
  $(".popup-container").addClass("loading1");

  let productUrl = $(this).attr("data-product-url");
  if (productUrl.includes("?")) {
    productUrl = `${productUrl}&view=quick-view`;
  } else {
    productUrl = `${productUrl}?view=quick-view`;
  }

  $("body").addClass("overflow-hidden");
  $("body").addClass("isbuyBlukOpen");
  $(".popup-overlay").removeClass("hidden");
  $(".popup-container").removeClass("hidden");

  $.ajax({
    url: `${productUrl}`,
    method: "GET",
    success: function (response) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(response, "text/html");
      var productInfoEl = doc.querySelector("product-info");

      if (productInfoEl) {
        $(".popup-content").html(productInfoEl.innerHTML);
      } else {
        var productEl = doc.querySelector(".product");
        $(".popup-content").html(productEl ? productEl.innerHTML : response);
      }

      // Add the 'removeProductModel' class to .product-media-modal.media-modal when the popup opens
      $(".product-media-modal.media-modal").addClass("removeProductModel");

      // Initialize Price/Ft and Project Calculator from DOM values
      initQuickViewPriceAndCalculator();

      $(".popup-content").removeClass("loading");
      $(".popup-container").removeClass("loading1");
    },
    error: function (_xhr, _status, error) {
      console.error("Product fetch error:", error);
      $(".popup-content").removeClass("loading");
      $(".popup-container").removeClass("loading1");
      $(".popup-content").html(
        "<p>Error loading content. Please try again.</p>"
      );
    },
  });
});

// Close popup and hide the product modal
$(".popup-close-button, .popup-overlay").on("click", function () {
  $(".popup-content").empty();
  $(".popup-content").html(`<div class="loader"></div>`);
  $(".popup-overlay").addClass("hidden");
  $("body").removeClass("overflow-hidden");
  $("body").removeClass("isbuyBlukOpen");
  $(".popup-container").addClass("hidden");
  
$("product-modal").remove();
  
  // Apply display:none when closing the popup by adding 'hidden' class
  $(".product-media-modal.media-modal").addClass("hidden");
});

// CSS to hide the element when .hidden is added

// Hide elements not needed in quick view popup

if ($("body").hasClass("fixture-collection")) {
  $("<style>")
    .text(
      ".popup-content .low-stock-alert," +
      ".popup-content .price_per_ft_main," +
      ".popup-content .custom_calculator { display: none !important; }"
    )
    .appendTo("head");
}

